var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wordcloud"}},[(_vm.words)?_c('wordcloud',{attrs:{"data":_vm.words,"nameKey":"name","valueKey":"value","color":_vm.myColors,"showTooltip":false}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }